<template>
  <div class="realize_wrap">
    <div class="realize_img">
      <div class="img_tit">
        <i :class="calcClass">{{$t("dynamic.title")}}</i>
        <div class="img_desc">{{$t("dynamic.subTitle")}}</div>
      </div>
    </div>
    <div class="realize_nav_wrap">
      <div class="breadcrumb">
        <img class="home-icon" src="@/assets/img/home/home.png" alt=""/>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("contactUs.title")}}</el-breadcrumb-item>
          <el-breadcrumb-item @click.native="handleNavigate" style="cursor: pointer;">{{$t("dynamic.title")}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="isDetail">{{articleTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div v-if="!isDetail" class="card-list" v-animate-on-scroll="'animate__fadeInUp'">
      <div
          class="card-item"
          v-for="(item, index) in cardList"
          :key="index"
          @click="handlerDetail(item, index)"
      >
        <div class="card-img">
          <img :src="item.image" alt="card-image" style="width: 100%; height: 100%;">
        </div>
        <div>
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-date">{{ item.date }}</p>
          <p class="card-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div v-if="!isDetail" class="pagination">
      <div class="left">{{$t("dynamic.pagination")}}</div>
      <div class="right">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="6">
        </el-pagination>
      </div>
    </div>
    <template v-if="isDetail">
      <Article1 v-if="articleIndex === 1"></Article1>
      <Article2 v-if="articleIndex === 2"></Article2>
      <Article3 v-if="articleIndex === 3"></Article3>
      <Article4 v-if="articleIndex === 4"></Article4>
      <Article5 v-if="articleIndex === 5"></Article5>
      <Article6 v-if="articleIndex === 6"></Article6>
    </template>
    <CallMe />
  </div>
</template>

<script>
/* eslint-disable */
import CallMe from '@/components/callme/index'
import Article1 from './article/1.vue'
import Article2 from './article/2.vue'
import Article3 from './article/3.vue'
import Article4 from './article/4.vue'
import Article5 from './article/5.vue'
import Article6 from './article/6.vue'
export default {
  computed: {
    cardList()
    {
      return [
        {
          image: require('@/assets/img/article/0724/1.webp'),
          title: '迪拜皇家拍卖公司董事局主席洪子晴爵士 拿督斯里与香港艺术家林文杰教授携手艺术赋能慈善公益',
          date: '2025-07-24',
          desc: '迪拜皇家拍卖公司董事局主席洪子晴爵士（HCC ROYAL AUCTION - FZCO）拍卖公司于2024年成立，积极推动中国与阿联酋贸易文化交流，2025年在迪拜举办第一届中国艺术品拍卖会，呈献古代和近现代中国书画、中国瓷器与工艺品、青铜器、茶道用具、文房四宝、珠宝及钟表等，预期在中国香港、巴黎、上海及北京进行预展。'
        },
        {
          image: require('@/assets/img/article/0719/1.webp'),
          title: '洪子晴女爵士 拿督斯里爱心助柬埔寨乡村部落孤儿入读当地大学圆读书梦',
          date: '2025-07-19',
          desc: '洪子晴女爵士拿督斯里（Lady Athena Hung Chi Ching,Dato\' Sri ）赞助柬埔寨乡村部落孤儿入读当地大学圆读书梦。'
        },
        {
          image: require('@/assets/img/article/0711/2.webp'),
          title: '拿督斯里洪子晴爵士为团长率国际潮商会长俱乐部出席第十二届国际潮青联谊年会-马来西亚盛会',
          date: '2025-07-11',
          desc: '马来西亚潮州公会联合会青年团（简称马潮联青）承办的2025年第十二届国际潮青联谊会于2025年7月8日至10日在马来西亚雪兰莪州万达镇One World Hotel（万达酒店）及M World Hotel隆重举行。汇聚全球逾1200名潮籍青年共襄盛举，年会以“潮聚大马，魅力所在”为主题，除了呈现马来西亚的多元文化特色，同时也颁发了多份奖项，表扬各地潮人所作出的贡献。'
        },
      {
        image: require('@/assets/img/article/0629/3.webp'),
        title: "Lady Athena Hung，Dato’ Sri, 2025Asia-Pacific Leaders Conference",
        date: '2025-06-29',
        desc: 'On April 8, 2025, the International Investment Salon of the Asia-Pacific Leaders Conference, hosted by Dr. Lawrence Yu, Founder of the Asia-Pacific Leaders Conference and Asia-Pacific Leaders Forum and Independent Director of the U.S. Rogers Pickleball Fund, grandly opened at the CFC Changfu Jinmao Building in Shenzhen. The event brought together more than 30 entrepreneurs, investors, financiers, and representatives from the cultural and sports sectors of China, Singapore, the United States, South Korea and other countries. Through the collision of cutting-edge ideas and in-depth cooperation discussions, they jointly explored new investment opportunities in the Asia-Pacific region.'
      },
      {
        image: require('@/assets/img/article/0629/3.webp'),
        title: '洪子晴爵士出席亚太领袖会2025国际投资沙龙&并担任亚太经济领袖联合会永远荣誉主席',
        date: '2025-06-27',
        desc: '2025年4月8日，由亞太領袖會暨亚太领袖论坛创始人、美国罗杰斯匹克球基金独董劳伦斯.余博士主办的亚太领袖会国际投资沙龙于深圳CFC长富金茂大厦盛大启幕。活动汇聚中国、新加坡、美国、韩国等30余位企业家、投资家、金融家及文体界代表，通过前沿观点碰撞与深度合作探讨，共拓亚太投资新机遇。'
      },
      {
        image: require('@/assets/img/article/0615/10.webp'),
        title: '洪子晴爵士与瑞典前首相约翰·弗雷德里克·赖因费尔特在上海相聚',
        date: '2025-06-15',
        desc: '2025年5月27日，上海迎来了一位重要的国际友人 —— 瑞典第八任首相约翰・弗雷德里克・赖因费尔特阁下。此次访华，赖因费尔特阁下带着促进中瑞交流合作的愿景，行程紧凑且意义非凡。'
      }
    ]
    },
    calcClass()
    {
      return (this.$i18n.locale === 'en' || this.$i18n.locale === 'ar') ? 'english-layout' : '';
    }
  },
  data() {
    return {
      articleTitle: '',
      isDetail: false,
      articleIndex: this.$route.query.articleIndex || -1
    }
  },
  methods: {
    handleNavigate()
    {
      this.isDetail = false;
      this.articleIndex = -1;
    },
    handlerDetail(item, index)
    {
        this.articleTitle = item.title;
        this.isDetail = true;
        this.articleIndex = (index + 1);
    }
  },
  components: {
    CallMe,
    Article1,
    Article2,
    Article3,
    Article4,
    Article5,
    Article6,
  },
  created(){
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    if(this.$route.query.articleIndex)
    {
      if(/^[1-6]$/.test(this.$route.query.articleIndex))
      {
        this.articleIndex = Number(this.$route.query.articleIndex);
        this.isDetail = true;
        this.articleTitle = this.cardList[this.articleIndex - 1].title
      }
    }
  },
  mounted() {
  },
  watch: {
    $route() {
      this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  position: relative;
  font-family: $font-family;
  background-color: #ffffff;
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-image: url('../../assets/img/dynamics/news.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    .img_tit {
      width: 70%;
      font-weight: bold;
      margin: 0 auto;
      transition: all 0.5s ease 0s;
      i{
        font-size: $banner-font-size;
        border-bottom: 4px #fff solid;
        padding-bottom: 10px;
        @media screen and (max-width: 768px) {
          font-size: $phone-banner-font-size;
        }
      }
    }
    .img_desc {
      font-size: $banner-sub-font-size;
      margin-top: 15px;
      text-transform:uppercase;
      @media screen and (max-width: 768px) {
        font-size: $phone-banner-sub-font-size;
      }
      outline:none;
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .realize_nav_wrap {
    width: 100%;
    margin: 0 auto;
    background-color: #f6f7f9;
    //height:50px;
    @media screen and (max-width: 768px) {
      //height: 50px;
      //padding: 20px;
      //margin-bottom: 20px;
    }
    .realize_nav {
      //height: 100%;
      display: flex;
      align-items: center;
      .active {
        font-weight: bold;
        color: #000;
      }
      .realize_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .nav_top {
          font-size: 18px;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
        .nav_bottom {
          width: 30%;
          height: 4px;
          margin-top: 10px;
          background: #2091d3;
        }
      }
    }
  }
  .breadcrumb{
    width: $about-width;
    margin: 0 auto;
    padding: 20px 0px;
    box-sizing: border-box;
    display: flex;
    background-color: #f6f7f9;
    .home-icon{
      height: 20px;
      width: 20px;
      margin-right: 15px;
      @media screen and (max-width: 768px) {
        height:0;
        width: 0;
        margin-right:0
      }
    }
    .el-breadcrumb{
      margin-top: 4px;
    }
  }
  @media screen and (max-width: 768px) {
    .breadcrumb{
      margin:0 0 0 10px;
      box-sizing: border-box;
      background-color: #FFFFFF;
      width: 90%;
      ::v-deep .el-breadcrumb{
        font-size: 0.8rem !important;
      }
    }
    .realize_nav_wrap {
      width: 100%;
      height: 0;
      margin-top: 15px;
      margin-bottom: 40px;
      background-color: #f6f7f9;
    }
  }
  /* 基础布局，每行3个，设置flex换行 */
  .card-list {
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px 0;
    box-sizing: border-box;
    /* 每个卡片样式，设置基础宽度，根据屏幕适配调整 */
    .card-item {
      width: calc(33.333% - 10px);
      margin-bottom: 1rem;
      background-color: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      cursor: pointer;
      overflow: hidden;
      &:hover{
        .card-title{
          color: #794bb7;
        }
      }
    }
    /* 图片样式，自适应容器宽度 */
    .card-img {
      width: 100%;
      height: 25vh;
      margin-bottom: 12px;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &:hover{
        img{
          transform: scale(1.1);
          transition: all .5s;
          object-fit: cover;
        }
      }
    }
    /* 标题样式，设置字体大小，通过媒体查询在移动端调整 */
    .card-title {
      font-size: 0.96rem;
      font-weight: bold;
      margin-bottom: 6px;
      padding: 0 1rem;
      line-height: 1.2;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /* 日期样式 */
    .card-date {
      font-size: 0.7rem;
      color: #999;
      margin-bottom: 8px;
      padding: 0 1rem;
    }
    /* 描述样式 */
    .card-desc {
      width: 100%;
      font-size: 0.8rem;
      color: #666;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      border-top: 1px solid #eee;
      padding: 0.8rem 1rem 0 1rem;
      margin-bottom: 1rem;
    }
  }

  /* 媒体查询，适配移动端小屏幕，调整字体和卡片宽度等 */
  @media (max-width: 768px) {
    .card-list {
      width: 90%;
      .card-item {
        width: calc(50% - 10px); /* 屏幕变窄时，每行2个也可，这里演示调整为更紧凑，也可仍保持3个适当缩小间距等，根据需求定 */
      }
      .card-title {
        font-size: 0.8rem;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        //padding:0.5rem 0;
        margin: 0.5rem 0rem 0.3rem 0;
      }
      .card-img{
        height: 25vh;
        margin-bottom: 12px;
        img{
          width: 100%;
          object-fit: cover;
        }
        //img{
        //  transform: scale(1.1);
        //  transition: all .5s;
        //}
      }
      .card-date,
      .card-desc {
        font-size: 0.8rem;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin:0.3rem 0;
      }
    }
    .pagination{
      .right{
        display: none;
      }
    }
  }

  @media (max-width: 480px) {
    .card-list {
      width: 94%;
      .card-item {
        width: 100%; /* 极小屏幕每行1个 */
      }
    }
    .pagination{
      .right{
        display: none;
      }
    }
  }

  .pagination{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 0 auto 20px auto;
    width: 70%;
    font-size: 0.8rem;
  }

  @media (max-width: 480px) {
    .realize_nav_wrap {
      width: 100%;
      //height: 10px;
      //margin: 0 !important;
    }
  }

}
</style>
